function filterDeleted<T extends { deleted?: boolean }>(parts: T[]): T[] {
    return parts.filter((part) => !part.deleted);
}

export default filterDeleted;
